import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { AlertTriangle, X } from 'lucide-react';
import { apiFetch } from '@/lib/api';
import { useT } from '@/lib/i18n';

// Estado da assinatura (Stripe). past_due/unpaid = cobrança falhou → avisa para pagar.
interface Sub { status: string }

// UsageBanner — alerta global de pagamento pendente da assinatura no topo das páginas.
// Visível só para admins; dispensável por sessão.
export function UsageBanner() {
  const t = useT();
  const [dismissed, setDismissed] = useState(false);
  const { data } = useQuery({
    queryKey: ['subscription', 'banner'],
    queryFn: async (): Promise<Sub | null> => {
      const r = await apiFetch('GET', '/me/subscription');
      return (r.ok ? r.data : null) as Sub | null;
    },
    staleTime: 60_000,
  });
  if (dismissed || !data) return null;
  const pastDue = data.status === 'past_due' || data.status === 'unpaid';
  if (!pastDue) return null;

  return (
    <div className="mb-4 flex items-start gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive">
      <AlertTriangle className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{t('usageBanner.pastDueTitle')}</p>
        <p className="text-destructive/90">{t('usageBanner.pastDueBodyInvoice')}</p>
      </div>
      <Link to="/billing" className="shrink-0 rounded-md bg-destructive px-2.5 py-1 text-xs font-semibold text-white">
        {t('usageBanner.viewInvoices')}
      </Link>
      <button onClick={() => setDismissed(true)} className="shrink-0 rounded p-0.5 opacity-60 transition-opacity hover:opacity-100" aria-label={t('usageBanner.dismiss')}>
        <X className="size-4" />
      </button>
    </div>
  );
}
